import {
  createContext,
  useContext,
  type Dispatch,
  type SetStateAction,
} from 'react';
import type { DateRange } from 'react-day-picker';
import type { ReceiptStatusFilter } from '../service/types';

export interface ReceiptsFiltersContextValue {
  searchDraft: string;
  onSearchChange: (nextQuery: string) => void;
  status: ReceiptStatusFilter | undefined;
  hasImage: boolean | undefined;
  statusOptions: ReadonlyArray<{ value: string; label: string }>;
  imageOptions: ReadonlyArray<{ value: string; label: string }>;
  selectedCustomRange: DateRange | undefined;
  customRange: DateRange | undefined;
  setCustomRange: Dispatch<SetStateAction<DateRange | undefined>>;
  isCustomRangeOpen: boolean;
  setCustomRangeOpen: Dispatch<SetStateAction<boolean>>;
  hasActiveDateRange: boolean;
  isCustomRangeValid: boolean;
  onClearDateRange: () => void;
  onApplyDateRange: () => void;
  hasResettableFilters: boolean;
  onStatusChange: (nextStatus: string) => void;
  onImageChange: (nextHasImage: string) => void;
  onResetFilters: () => void;
  pageSize: number;
  pageSizeOptions: ReadonlyArray<number>;
  onPageSizeChange: (nextValue: string) => void;
}

export const receiptsFiltersContext = createContext<ReceiptsFiltersContextValue | null>(null);

export function useReceiptsFilters() {
  const value = useContext(receiptsFiltersContext);
  if (value === null) {
    throw new Error('useReceiptsFilters must be used within ReceiptsPageProvider');
  }
  return value;
}
